import _styled from '@emotion/styled/base';
import { Flex } from '../Flex/index.js';
import { mediaQuery } from '../primitives/media-queries.js';
import { Spacing } from '../primitives/spacing.js';
import { Text } from '../Text/index.js';

const flexColStyles = `
    flex-direction: column;
    justify-content: center;
`;
const stackedButtonSpacing = `
  margin-top: ${Spacing.scale[1.5]};
  margin-left: ${Spacing.scale[4]};
`;
const SystemAlertWrapper = _styled(Flex, {
  target: "exx2y0p2"
})("position:sticky;top:0;width:100%;z-index:102;user-select:text;background:", ({
  variant,
  theme
}) => theme.colorScheme.status.bold.background[variant], ";color:", ({
  theme
}) => theme.colorScheme.content.primary, ";", ({
  hasActionButton
}) => {
  return hasActionButton && flexColStyles;
}, "@media ", mediaQuery.mobileXsDown, "{", flexColStyles, ";}");
const SystemAlertButtonContainer = _styled("div", {
  target: "exx2y0p1"
})(({
  hasActionButton
}) => {
  return hasActionButton && stackedButtonSpacing;
}, "@media ", mediaQuery.mobileXsDown, "{", stackedButtonSpacing, ";}");
const SystemAlertText = _styled(Text.Body, {
  target: "exx2y0p0"
})({
  name: "ddxhyk",
  styles: "max-width:800px"
} );

export { SystemAlertButtonContainer, SystemAlertText, SystemAlertWrapper };
